import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { ReducerObj } from "../../types/interface";
import { getAllPublisher } from "../../api/browserGetPublisher";
import objectToQueryString from "../../screens/browseJournal/objToQuery";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { publisherSearchResult } from "../../store/slice/browserPublisher";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import {
  updateBrowserPage,
  updateBrowserRow,
  updateBrowserPage as updateBrowserPagePublisher,
  updateCurrentUpdate,
  clearAllFilters,
  updatepublishercollection,
  updateselectAlphabetPublisher,
} from "../../store/slice/browserFilterSlicePublisher";
import { setSearchKeywordPublisher } from "../../store/slice/browserPublisher";
import {
  getContainOrStartingWIth,
  updateknownAlphasearch,
} from "../../store/slice/browseJournal";
import { MathJax } from "better-react-mathjax";
import NoResultModal from "../modals/NoResultFound";
import { Divider, Drawer, Typography } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { usagelogApi } from "../../api/usageReportApi";
import {
  clearJournalDataType,
  updatecollection,
  updateSort,
  updateSortName,
} from "../../store/slice/browseFilterSlice";
import { Clear, FilterAlt } from "@mui/icons-material";
import SearchFilterComponentOfPublisher from "../leftBarComponent/searchFilterOfPublisher";
import {
  updateBrowserRow as updateBrowserRowAtoZ,
  updateBrowserPage as updateBrowserPageAtoZ,
} from "../../store/slice/browseFilterSlice";
import { escapeQuerySpecialCharacter } from "../../utils/validateSearchTerm";

import { getContainOrStartingWIth as getContainOrStartingWIthForPackage } from "../../store/slice/browsePackage";
import { goToTop } from "../../utils/helper";
import SearchFilterOfONOSPublisher from "../leftBarComponent/searchFilterOfONOSResources";

export default function PublisherONOS(props: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let session_key = sessionStorage.getItem("session_key");
  let userId = sessionStorage.getItem("user_id");

  const [FilterDrawer, setFilterDrawer] = React.useState(false);
  const [noresultModal, setNoResultModal] = React.useState<any>(false);
  const [message, setMessage] = React.useState({ messages: "", open: false });

  const oNOSPublisherResults = useSelector(
    (state: any) =>
      state.browserPublisher?.browserResult?.grouped?.onos_publisher_name,
  );
  // browserFilterSlicePublisher
  const rows = useSelector(
    (state: any) => state.browserFilterSlicePublisher.rows,
  );
  // ngroups

  const currentPage = useSelector(
    (state: any) => state.browserFilterSlicePublisher.page,
  );

  const setAlphabet: any = useSelector(
    (state: any) => state.browserFilterSlicePublisher.selectAlphabet,
  );
  let count = Math.ceil(oNOSPublisherResults?.ngroups / rows);

  const openAccess = useAppSelector(
    (state) => state.browserFilterSlicePublisher.currentUpdate,
  );

  const searchReducer: any = useSelector(
    (state: ReducerObj) => state.searchReducer,
  );

  const keyWords = useSelector(
    (state: any) => state.browserPublisher?.searchKeyword,
  );

  const independentFilter = useSelector(
    (state: any) => state.browserFilterSlicePublisher.currentUpdate,
  );

  const publisherDetails: any = useSelector(
    (state: any) =>
      state.browserPublisher?.browserResult?.grouped?.onos_publisher_name
        ?.groups,
  );

  const profileData = useAppSelector((state) => state.login);
  const profileData1 = useAppSelector(
    (state) => state.customer.customerDetails,
  );

  const selectedPublisherFilters: any = useSelector(
    (state: any) => state.browserFilterSlicePublisher,
  );

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setMessage({
      messages: "",
      open: false,
    });
  };
  async function closeNoResultModal() {
    dispatch(clearAllFilters());
    dispatch(updateBrowserPagePublisher(1));
    dispatch(setSearchKeywordPublisher([]));
    props.setKeyWordPublisher("");
    props.setFilters("");
    props.setMyPersonalLibraryPublisher(false);
    dispatch(updatepublishercollection("J-GateCollection"));
    dispatch(updatecollection("J-GateCollection"));
    setNoResultModal(false);
  }

  const setJournalResults = async () => {
    try {
      let subjects = "";
      let dataTypes = "";

      if (searchReducer.subjectType?.length > 0) {
        searchReducer.subjectType?.map((element: any) => {
          subjects += `${element} OR `;
        });
        subjects = `(${subjects.slice(0, -3)})`;
      }

      if (searchReducer?.defaultDataType?.length > 0) {
        searchReducer?.defaultDataType?.map((element: any) => {
          dataTypes += `${element} OR `;
        });
        dataTypes = `(${dataTypes.slice(0, -3)})`;
      }

      let resourceList = "";

      keyWords?.map((element: any) => {
        if (element.searchType === "Starting With") {
          resourceList += `${element.words.replace(/ /g, "\\ ")}* AND `;
        } else if (element.searchType == "Containing") {
          resourceList += `*${element.words.replace(/ /g, "\\ ")}* AND `;
        }
      });

      resourceList = encodeURIComponent(`${resourceList.slice(0, -4)}`);
      let apiJournalData: any = {
        page: currentPage,
        rows: rows,
        profileuserid: userId,
        sessionid: session_key,
        facet_fields:
          "publisher_name,primary_publisher_country,subjects_name_l3,resource_source_index,filter_metrix,publisher_name_initial,onos_publisher_name,onos_publisher_initial",
        sort: "onos_publisher_name asc",
        op_mode: "and",
        // fl: "publisher_name_tk, primary_publisher_country,publisher_id,",
        fl: "onos_publisher_name, onos_publisher_id",
        group_field: "onos_publisher_name",
        group_ngroups: true,
        // fq__subjects_id_l2: subjects,
        json_facet: JSON.stringify({
          subjects_name_l2: {
            type: "terms",
            field: "subjects_name_l2",
            limit: 100,
            sort: "index asc",
            facet: {
              subjects_name_l3: {
                type: "terms",
                field: "subjects_name_l3",
                limit: 60,
                // sort: "index asc",
              },
            },
          },
          data_type: { type: "terms", field: "data_type", limit: 30 },
        }),
        fq__is_onos_resource: true,
      };
      if (independentFilter)
        Object.assign(apiJournalData, {
          fq__dateofpublication: "[NOW/YEAR TO NOW/YEAR]",
          fq__createddate: "[NOW-60DAYS TO NOW]",
        });
      Object.assign(apiJournalData, { fq__subjects_id_l2: subjects });

      // if (subjects.length) {
      //   Object.assign(apiJournalData, {
      //     "fq__(subjects_id_l2": `${subjects} OR is_onos_resource=true)`,
      //   });
      // }
      if (dataTypes.length > 2)
        Object.assign(apiJournalData, { fq__resource_type: dataTypes });

      if (resourceList.length > 2)
        Object.assign(apiJournalData, {
          onos_publisher_name: escapeQuerySpecialCharacter(resourceList),
        });
      if (setAlphabet !== "" && setAlphabet !== "0-9")
        Object.assign(apiJournalData, {
          onos_publisher_initial: `${escapeQuerySpecialCharacter(setAlphabet)}`,
        });

      let response;

      if (props.myPersonalLibraryPublisher) {
        if (props.filters == undefined) {
          response = await getAllPublisher(
            "personalresourcecore?" + objectToQueryString(apiJournalData),
          );
        } else {
          response = await getAllPublisher(
            "personalresourcecore?" +
              objectToQueryString(apiJournalData) +
              props.filters,
          );
        }
      } else {
        if (props.filters == undefined) {
          response = await getAllPublisher(
            "resourcecore?" + objectToQueryString(apiJournalData),
          );
        } else {
          response = await getAllPublisher(
            "resourcecore?" +
              objectToQueryString(apiJournalData) +
              props.filters,
          );
        }
      }
      if (
        props.filters &&
        props.filters.includes("&fq__fulltext_ACL=") &&
        response?.data?.data?.grouped?.onos_publisher_name?.groups.length === 0
      ) {
        setMessage({
          messages:
            "There are no configured subjects nor subscription information for your library . Please contact your library administrator.",
          open: true,
        });

        dispatch(publisherSearchResult(response?.data.data));
        const updatedFilters = props.filters.replace(
          /&fq__fulltext_ACL=[^&]*/g,
          "",
        );
        props.setFiltersPublisher(updatedFilters);
        setNoResultModal(true);
        return;
      }

      if (
        response?.data.data.grouped.onos_publisher_name.ngroups == 0 ||
        response == undefined
      ) {
        setNoResultModal(true);
      }
      dispatch(publisherSearchResult(response?.data.data));

      let enabledTagsList: any[] = ["ALL", "(0-9)"];
      if (setAlphabet === "") {
        response?.data.data.facets.facet_fields?.onos_publisher_initial?.map(
          (ele: any) =>
            Object.keys(ele)[0]?.charAt(0)?.toUpperCase().match(/[a-z]/i)
              ? enabledTagsList.push(
                  Object.keys(ele)[0]?.charAt(0)?.toUpperCase(),
                )
              : null,
        );
        dispatch(updateknownAlphasearch(enabledTagsList));
      }
    } catch (err) {
      setNoResultModal(true);
    }
  };

  React.useEffect(() => {
    // for 1794
    // dispatch(updateCurrentUpdate(false));
    dispatch(updateSort("resource_name_tk asc"));
    // dispatch(updateSortName("Journal"));
    dispatch(updateSortName("Title"));
    dispatch(updateBrowserRowAtoZ(15));
    dispatch(updateBrowserPageAtoZ(1));
    dispatch(getContainOrStartingWIth("Starting With"));
    dispatch(getContainOrStartingWIthForPackage("Starting With"));
    dispatch(clearJournalDataType());
  }, []);

  React.useEffect(() => {
    dispatch(updateselectAlphabetPublisher(""));
    const debounce = setTimeout(() => {
      setJournalResults();
    }, 100);

    return () => {
      clearTimeout(debounce);
    };
  }, [
    props.selectedTagPublisher,
    keyWords,
    props.filters,
    currentPage,
    independentFilter,
    rows,
    props.myPersonalLibraryPublisher,
    searchReducer.subjectType,
    searchReducer.defaultDataType,
  ]);

  React.useEffect(() => {
    if (props.publisher) {
      props.setpublisher(false);
      setJournalResults();
    }
    return () => {
      dispatch(setSearchKeywordPublisher([]));
    };
  }, [props.publisher]);

  const contextId =
    selectedPublisherFilters.collectionsValuePublisher === "J-GateCollection"
      ? 1
      : selectedPublisherFilters.collectionsValuePublisher ===
          "Consortia Collections"
        ? 2
        : selectedPublisherFilters.collectionsValuePublisher ===
            "My Library Collections"
          ? 3
          : selectedPublisherFilters.collectionsValuePublisher ===
              "MyPersonalLibraryCollection"
            ? 4
            : selectedPublisherFilters.collectionsValuePublisher ===
                "ONOS Collections"
              ? 5
              : selectedPublisherFilters.collectionsValuePublisher ===
                  "Library OPAC"
                ? 6
                : selectedPublisherFilters.collectionsValuePublisher ===
                    "Open Access Collections"
                  ? 7
                  : null;

  const logJournalFinderUsageData = (usageActionID: any) => {
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id ? profileData.user_id : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      contextId,
      null,
      null,
      null,
      null,
      null,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
    );
  };

  function handlePageChange(p: any) {
    dispatch(updateBrowserPage(p));
    goToTop();
  }
  function getRowsPerPage(value: number) {
    dispatch(updateBrowserRow(value));
    goToTop();
  }

  const handlePublisherClick = (element: any, props: any) => {
    navigate("/BrowseJournalTableSearch/PackageArticle", {
      state: {
        publisherId: element?.doclist?.docs[0]?.onos_publisher_id,
        publisherName: element?.doclist?.docs[0]?.onos_publisher_name,
        publisherFilter: props?.filters,
        packageDetails: element?.doclist?.docs[0],
        from: "publisherONOS",
      },
    });
  };

  return (
    <Box>
      <Box
        sx={{
          display: {
            xs: "flex",
            sm: "flex",
            md: "none",
            lg: "none",
            xl: "none",
          },
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: {
              xs: "flex",
              sm: "flex",
              md: "none",
              lg: "none",
              xl: "none",
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Lora",
              fontWeight: 700,
              fontSize: { xs: 18, sm: 22 },
            }}
          >
            Results{" "}
            {oNOSPublisherResults?.ngroups
              ? oNOSPublisherResults.ngroups.toLocaleString("en-US")
              : ""}
          </Typography>
        </Box>
        <IconButton
          sx={{
            display: { xs: "flex", sm: "flex", md: "none" },
            mr: { xs: "8px", sm: "15px" },
            alignItems: "center",
          }}
          onClick={() => {
            setFilterDrawer(true);
          }}
          size="small"
          color="primary"
        >
          <FilterAlt />
        </IconButton>
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: { xs: "1%", sm: "1%", md: "8%", lg: "5.7%", xl: "4%" },
        }}
      >
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFB" }}>
              <TableCell>Publisher Name</TableCell>
              {/* <TableCell>Country</TableCell> */}

              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {publisherDetails
              ?.filter(
                (element: any) =>
                  element?.doclist?.docs?.length > 0 &&
                  Object.keys(element.doclist.docs[0]).length > 0,
              )
              .map((element: any) => {
                return (
                  <TableRow>
                    <TableCell
                      onClick={() => handlePublisherClick(element, props)}
                      sx={{ cursor: "pointer" }}
                    >
                      <MathJax>
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              element?.doclist?.docs[0]?.onos_publisher_name,
                          }}
                        />
                      </MathJax>
                    </TableCell>
                    {/* <TableCell>
                    {element?.doclist?.docs[0].primary_publisher_country}
                  </TableCell> */}

                    <TableCell>
                      <ArrowForwardIosIcon
                        onClick={() => handlePublisherClick(element, props)}
                        fontSize="small"
                        style={{ alignSelf: "center", cursor: "pointer" }}
                      ></ArrowForwardIosIcon>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Snackbar
        open={message.open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert severity="warning" sx={{ width: "100%" }}>
          {message.messages}
        </Alert>
      </Snackbar>
      <Box my={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          count={count}
          handlePageChange={handlePageChange}
          rowsPerResult={rows}
          getRowsPerPage={getRowsPerPage}
          currentPage={currentPage}
        />
        {/* <Spinner isLoading={isLoading} /> */}
      </Box>
      <NoResultModal isOpen={noresultModal} handleClose={closeNoResultModal} />

      <Drawer
        open={true}
        onClose={() => setFilterDrawer(false)}
        anchor="left"
        sx={{ display: FilterDrawer ? "block" : "none" }}
        ModalProps={{
          disableScrollLock: true, // ✅ Keeps parent page scrollable
        }}
      >
        <Box bgcolor={"#FFF"} width={"100%"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              alignSelf: "center",
              padding: "1%",
            }}
          >
            <Typography
              variant="h6"
              fontFamily={"Lora"}
              fontWeight={"700"}
              fontSize={"24px"}
            >
              Filters
            </Typography>
            <IconButton
              aria-label="delete"
              size="small"
              onClick={() => {
                setFilterDrawer(false);
              }}
            >
              <Clear />
            </IconButton>
          </Box>
        </Box>
        <Divider></Divider>
        <Box width={"100%"}>
          <SearchFilterOfONOSPublisher
            setFilters={props.setFilters}
            setFilterDrawer={setFilterDrawer}
            from="onosPublisher"
          ></SearchFilterOfONOSPublisher>
        </Box>
      </Drawer>
    </Box>
  );
}
